import { Component, Inject, Injector } from '@angular/core';
import { DashboardCartAndSettings } from '@cloud-twin-v2/cloud-twin-shared/filtrable-items/dashboard-cart-and-settings';
import { TextWidgetSettings } from '@cloud-twin-v2/cloud-twin-shared/filtrable-items/widget-settings';
import { WidgetSettingsToken } from '@common-modules/dynamic-layout/dynamic-layout.tokens';
import { StateWidgetSettings } from '@common-modules/redux/models/state-widget-settings';
import { DashboardChildWidgetParams } from '@common-modules/right-panel/dashboards/dashboard-widget-params';
import { TextConfiguration } from '@common-modules/shared/core/text/text-configuration';
import { globalUtilsHelper } from '@common-modules/shared/helpers/global-utils-helper';
import { plainToClass } from 'class-transformer';
import { BaseDashboardWidgetComponent } from '../core/base-dashboard-widget-component';

@Component({
  selector: 'ct-dashboard-text-widget',
  templateUrl: './dashboard-text-widget.component.html',
  styleUrl: './dashboard-text-widget.component.scss',
  standalone: false,
})
export class DashboardTextWidgetComponent extends BaseDashboardWidgetComponent {
  private _currentWidgetSettings: StateWidgetSettings;

  textConfiguration: TextConfiguration;

  constructor(
    injector: Injector,
    @Inject(WidgetSettingsToken) widgetSettings: StateWidgetSettings
  ) {
    super(injector, widgetSettings);
    this._currentWidgetSettings = widgetSettings;
    this.setTextConfiguration(widgetSettings.params);
  }

  get componentName(): string {
    return 'DashboardTextWidgetComponent';
  }

  onWidgetInit(): void {
    this.listenSettingsChange();
  }

  reload(updatedParams: DashboardCartAndSettings) {
    if (
      updatedParams.widgetSettings &&
      'textConfiguration' in updatedParams.widgetSettings &&
      updatedParams.widgetSettings.textConfiguration
    ) {
      const config = updatedParams.widgetSettings.textConfiguration as TextConfiguration;

      const widgetSettings = new TextWidgetSettings();
      widgetSettings.textConfiguration = config;
      updatedParams.widgetSettings = widgetSettings;
      if (this._widgetSettings.itemSettings) {
        this._widgetSettings.itemSettings.params = updatedParams;
      }
      this.setTextConfiguration(updatedParams);
    }
  }

  onTextConfigurationChange(textConfiguration: TextConfiguration) {
    const setting = globalUtilsHelper.clone(
      this._widgetSettings.itemSettings?.params
    ) as DashboardCartAndSettings;
    const gridWidgetSettings = new TextWidgetSettings();
    gridWidgetSettings.textConfiguration = textConfiguration;
    setting.widgetSettings = gridWidgetSettings;

    this.updateItemSettings({
      title: this.textConfiguration.textName || this._settings.title,
      params: setting,
      widgetInstanceKey: this.getWidgetInstanceKey(),
    });
  }

  private setTextConfiguration(params: DashboardChildWidgetParams) {
    if (!params) {
      return;
    }

    const dashboardCart: DashboardCartAndSettings = plainToClass(DashboardCartAndSettings, params);
    let textConfig: TextConfiguration;

    if (
      dashboardCart.widgetSettings &&
      (dashboardCart.widgetSettings as TextWidgetSettings).textConfiguration
    ) {
      textConfig = (dashboardCart.widgetSettings as TextWidgetSettings).textConfiguration;
    } else {
      textConfig = new TextConfiguration();
      textConfig.textContent = '';
      textConfig.textName = '';
    }

    this.textConfiguration = textConfig;
    this.onTextConfigurationChange(this.textConfiguration);
  }
}
